'use client';

import { useEffect, useState, useRef } from 'react';
import Cabecalho from '../../components/tipografia/Cabecalho';
import Texto from '../../components/tipografia/Texto';
import CampoTexto from '../../components/Formulario/CampoTexto';
import VBox from '../../components/layout/VBox';
import Botao from '../../components/Botao';
import HBox from '../../components/layout/HBox';
import CampoCheckbox from '../../components/Formulario/CampoCheckbox';
import { mdiPauseCircle, mdiPlayCircle, mdiLoading, mdiCheckCircle, mdiLinkVariant, mdiArrowLeft } from '@mdi/js';
import useWindowSize from '../../lib/useWindowSize';
import { LoginBackground, useLoginBackground } from './bg/LoginBackground';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/useAuth';
import CampoSenha from '../../components/Formulario/CampoSenha';
import AlertBox from '@/components/layout/AlertBox';
import { Link } from '@/components/layout/Link';
import Icon from '@/components/Icon';
import axios from 'axios';

type PageMode = 'login' | 'forgot-password' | 'forgot-password-success';
type RequestType = 'password-reset' | 'magic-link';

const Page = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const s = new URLSearchParams(window.location.search);
  const redirPath = s.get('r') ?? '/chat';
  const esqueciSenha = s.get('esqueci-senha') === 'true';

  console.log('redir path', redirPath);

  useEffect(() => {
    if (user) navigate(redirPath);
  }, [user, navigate, redirPath]);

  const [width, height, mobile] = useWindowSize();

  const [pause, setPause] = useState(false);
  const bg = useLoginBackground();
  const [mode, setMode] = useState<PageMode>(esqueciSenha ? 'forgot-password' : 'login');

  // Refs para controlar o foco
  const usuarioInputRef = useRef<HTMLInputElement>(null);
  const emailInputRef = useRef<HTMLInputElement>(null);

  // Login states
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [lembrar, setLembrar] = useState(true);
  const [loginError, setLoginError] = useState<string | null>(null);

  // Forgot password states
  const [email, setEmail] = useState('');
  const [forgotPasswordError, setForgotPasswordError] = useState('');
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  const [magicLinkLoading, setMagicLinkLoading] = useState(false);
  const [requestType, setRequestType] = useState<RequestType>('password-reset');

  // Dar foco ao campo correto quando o modo mudar
  useEffect(() => {
    // Aguardar um pouco para a transição CSS completar
    const timer = setTimeout(() => {
      if (mode === 'login' && usuarioInputRef.current) {
        usuarioInputRef.current.focus();
      } else if (mode === 'forgot-password' && emailInputRef.current) {
        emailInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [mode]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoginError(null);

    try {
      const result = await axios.post('/api/login', {
        username: usuario,
        password: senha,
      });
      setLoginError('');
      console.log('result', result);

      if (result.data.ok) navigate(redirPath);
      else setLoginError('Usuário ou senha inválidos');
    } catch (e) {
      if (axios.isAxiosError(e) && e.response) {
        if (e.response.status === 400) {
          setLoginError('Usuário ou senha inválidos.');
        } else if (e.response.status === 429) {
          setLoginError('Limite de usuários online atingido. Tente novamente mais tarde.');
        } else {
          setLoginError('Erro ao tentar fazer login. Tente novamente mais tarde.');
        }
      }
      else {
        console.error('Erro desconhecido ao fazer login:', e);
        setLoginError('Erro ao tentar login. Tente novamente mais tarde.');
      }
    }
  };

  const handleForgotPassword = async (e: React.FormEvent, type: RequestType = 'password-reset') => {
    e.preventDefault();

    if (!email) {
      setForgotPasswordError('Por favor, informe seu email.');
      return;
    }

    setRequestType(type);
    if (type === 'magic-link') {
      setMagicLinkLoading(true);
    } else {
      setForgotPasswordLoading(true);
    }
    setForgotPasswordError('');

    try {
      const endpoint = type === 'magic-link' ? '/api/auth/magic-link/request' : '/api/forgot-password';
      const response = await axios.post(endpoint, { email });

      if (response.data.ok) {
        setMode('forgot-password-success');
      }
    } catch (error: any) {
      if (axios.isAxiosError(error) && error.response) {
        if (error.response.status === 429) {
          setForgotPasswordError(error.response.data.msg);
        } else {
          setForgotPasswordError(error.response.data.msg || 'Erro ao processar solicitação');
        }
      } else {
        setForgotPasswordError('Erro ao processar solicitação. Tente novamente mais tarde.');
      }
    } finally {
      setForgotPasswordLoading(false);
      setMagicLinkLoading(false);
    }
  };

  const switchToForgotPassword = () => {
    setMode('forgot-password');
    setLoginError(null);
    setForgotPasswordError('');
  };

  const switchToLogin = () => {
    setMode('login');
    setForgotPasswordError('');
    setLoginError(null);
    setEmail('');
  };

  // useEffect(() => {
  //   me().then((user: any) => {
  //     console.log('user', user)
  //     if (user) {
  //       return redirect("/");
  //     }
  //   })
  // }, [])

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10rem',
      }}
    >
      {!mobile && (
        <img
          src="/logo-terachat-branco.png"
          alt="Logo TeraChat"
          style={{ width: '25%' }}
        />
      )}
      <div>
        <div
          style={{
            minWidth: '400px',
            width: mobile ? '95%' : '25%',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            borderRadius: '24px',
            padding: '40px',
            position: 'relative',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.18)',
            transition: 'all 0.3s ease',
            background: 'linear-gradient(to bottom right, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
            overflow: 'hidden',
          }}
        >
          {mobile && (
            <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
              <img
                src="/logo-terachat-branco.png"
                alt="Logo TeraChat"
                style={{ width: '30%' }}
              />
            </div>
          )}

          <div style={{ position: 'relative', minHeight: '400px' }}>
            {/* Login Form */}
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: 0,
                right: 0,
                transform: mode === 'login' ? 'translateY(-50%)' : 'translate(-20px, -50%)',
                opacity: mode === 'login' ? 1 : 0,
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                pointerEvents: mode === 'login' ? 'auto' : 'none',
                width: '100%',
              }}
            >
              <h2 style={{
                width: '100%',
                textAlign: 'center',
                fontSize: '28px',
                fontWeight: '600',
                color: 'var(--tc-color-gray-800)',
                marginBottom: '1.5rem'
              }}>Bem-vindo de volta!</h2>

              <form onSubmit={handleSubmit}>
                <VBox>
                  <CampoTexto
                    ref={usuarioInputRef}
                    name="username"
                    tabIndex={1}
                    label="Usuário"
                    placeholder="Insira seu usuário"
                    type="text"
                    value={usuario}
                    onChange={setUsuario}
                    required
                  />

                  <CampoSenha
                    name="password"
                    tabIndex={2}
                    label="Senha"
                    placeholder="Insira sua senha"
                    type="text"
                    value={senha}
                    onChange={setSenha}
                    required
                  />

                  <HBox style={{ justifyContent: 'flex-end', marginTop: -8, marginBottom: 8 }}>
                    <button
                      type="button"
                      onClick={switchToForgotPassword}
                      style={{
                        fontSize: '14px',
                        color: 'var(--tc-color-primary-700)',
                        textDecoration: 'none',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                        transition: 'color 0.2s ease',
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                      onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                    >
                      Não sei a senha
                    </button>
                  </HBox>

                  <HBox>
                    <CampoCheckbox
                      value={lembrar}
                      onChange={setLembrar}
                      tabIndex={3}
                    >
                      Lembrar meus dados
                    </CampoCheckbox>
                  </HBox>
                  {loginError && <AlertBox variant="danger">{loginError}</AlertBox>}
                  <Botao
                    style={{ width: '100%' }}
                    type="submit"
                    variant="primary"
                    tabIndex={4}
                  >
                    Entrar
                  </Botao>
                </VBox>
              </form>
            </div>

            {/* Forgot Password Form */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                opacity: mode === 'forgot-password' ? 1 : 0,
                transform: mode === 'forgot-password' ? 'translateX(0)' : 'translateX(20px)',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                pointerEvents: mode === 'forgot-password' ? 'auto' : 'none',
                width: '100%'
              }}
            >
              <HBox style={{ marginBottom: '1rem', alignItems: 'center', gap: 8 }}>
                <button
                  type="button"
                  onClick={switchToLogin}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    color: 'var(--tc-color-primary)',
                    transition: 'transform 0.2s ease',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(-4px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
                >
                  <Icon path={mdiArrowLeft} size={1.5} />
                </button>
                <h2 style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: 'var(--tc-color-gray-800)',
                  margin: 0,
                }}>Esqueceu sua senha? 🔑</h2>
              </HBox>

              {forgotPasswordError && (
                <AlertBox variant="danger" style={{ marginBottom: 16 }}>
                  {forgotPasswordError}
                </AlertBox>
              )}

              <form onSubmit={(e) => handleForgotPassword(e, 'password-reset')}>
                <VBox>
                  <CampoTexto
                    ref={emailInputRef}
                    name="email"
                    label="Email"
                    value={email}
                    onChange={setEmail}
                    type="email"
                    placeholder="seu@email.com"
                    disabled={forgotPasswordLoading || magicLinkLoading}
                    required
                  />

                  <p style={{
                    textAlign: 'center',
                    fontSize: '16px',
                    color: 'var(--tc-color-gray-800)',
                    lineHeight: '1.5',
                    marginBottom: '24px',
                  }}>
                    Informe seu email e enviaremos instruções para redefinir sua senha.
                  </p>

                  <Botao
                    type="submit"
                    disabled={forgotPasswordLoading || magicLinkLoading || !email}
                    style={{ width: '100%' }}
                    variant="primary"
                  >
                    {forgotPasswordLoading ? (
                      <HBox gap={8} style={{ justifyContent: 'center' }}>
                        <Icon path={mdiLoading} size={0.8} spin />
                        Enviando...
                      </HBox>
                    ) : (
                      'Redefinir Senha'
                    )}
                  </Botao>

                  <div style={{
                    position: 'relative',
                    textAlign: 'center',
                    margin: '16px 0',
                    color: 'var(--tc-color-gray-600)'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: 0,
                      right: 0,
                      height: '1px',
                      backgroundColor: 'var(--tc-color-gray-300)',
                      zIndex: 0
                    }}></div>
                    <span style={{
                      position: 'relative',
                      padding: '0 16px',
                      backgroundColor: 'rgba(255, 255, 255, 0.5)',
                      zIndex: 1,
                      fontSize: '14px'
                    }}>ou</span>
                  </div>

                  <Botao
                    type="button"
                    onClick={(e) => handleForgotPassword(e as any, 'magic-link')}
                    disabled={forgotPasswordLoading || magicLinkLoading || !email}
                    style={{ width: '100%' }}
                    variant="secondary"
                    icon={mdiLinkVariant}
                  >
                    {magicLinkLoading ? (
                      <HBox gap={8} style={{ justifyContent: 'center' }}>
                        <Icon path={mdiLoading} size={0.8} spin />
                        Enviando...
                      </HBox>
                    ) : (
                      'Enviar Link para Acesso'
                    )}
                  </Botao>
                </VBox>
              </form>
            </div>

            {/* Success Message */}
            {mode === 'forgot-password-success' && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  opacity: mode === 'forgot-password-success' ? 1 : 0,
                  transform: mode === 'forgot-password-success' ? 'scale(1)' : 'scale(0.95)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  pointerEvents: mode === 'forgot-password-success' ? 'auto' : 'none',
                  width: '100%'
                }}
              >
                <VBox style={{ textAlign: 'center', gap: 16 }}>
                  <div>
                    <Icon
                      path={mdiCheckCircle}
                      size={3}
                      color="var(--tc-color-success)"
                    />
                  </div>
                  <h2 style={{
                    fontSize: '28px',
                    fontWeight: '600',
                    color: 'var(--tc-color-gray-900)'
                  }}>Email Enviado!</h2>
                  <p style={{
                    fontSize: '16px',
                    color: 'var(--tc-color-gray-800)',
                    lineHeight: '1.5',
                    margin: 0,
                  }}>
                    {requestType === 'magic-link'
                      ? 'Enviamos um link de acesso para o e-mail cadastrado.'
                      : 'Enviamos instruções para o e-mail cadastrado.'}
                  </p>
                  <p style={{
                    fontSize: '16px',
                    color: 'var(--tc-color-gray-800)',
                    lineHeight: '1.5',
                    margin: 0,
                  }}>
                    {requestType === 'magic-link'
                      ? 'Verifique sua caixa de entrada e clique no link para acessar sua conta.'
                      : 'Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.'}
                  </p>
                  <p style={{
                    fontSize: '14px',
                    color: 'var(--tc-color-gray-700)',
                    lineHeight: '1.4',
                  }}>
                    Não recebeu o email? Verifique sua pasta de spam ou aguarde alguns minutos.
                  </p>

                  <Botao
                    onClick={switchToLogin}
                    style={{ marginTop: '1rem', width: '100%' }}
                    variant="primary"
                  >
                    Voltar para Login
                  </Botao>

                  <p style={{
                    marginTop: '0.5rem',
                    fontSize: '14px',
                    fontStyle: 'italic',
                    color: 'var(--tc-color-gray-700)',
                    lineHeight: '1.4',
                  }}>(Ou feche esta janela)</p>
                </VBox>
              </div>
            )}
          </div>
        </div>
        <div style={{ width: '400px', marginTop: '0.5rem', textAlign: 'center', color: 'var(--tc-color-gray-500)', fontStyle: 'italic', fontSize: '0.8rem' }}>
          Made with ❤️ by <Link href="https://terachat.com.br" target="_blank">Tera Sistemas</Link>
        </div>
      </div>
      {/* Só o fundo "animado" aceita pausa; os outros já param com a aba oculta e respeitam reduced-motion. */}
      {bg === 'animado' && <div style={{ position: 'absolute', top: 10, right: 10 }}>
        {!pause && (
          <Botao
            variant="transparent"
            onClick={() => {
              setPause(true);
            }}
            icon={mdiPauseCircle}
            tabIndex={0}
          >
            Pausar animação
          </Botao>
        )}
        {pause && (
          <Botao
            variant="transparent"
            onClick={() => {
              setPause(false);
            }}
            icon={mdiPlayCircle}
            tabIndex={0}
          >
            Continuar animação
          </Botao>
        )}
      </div>}
      <LoginBackground bg={bg} width={width} height={height} pause={pause} />
    </div>
  );
};

export default Page;
